/**
 * Gravity Forms — Floating Label
 *
 * Adds/removes a `gf-floating` class on email fields inside the footer
 * newsletter form and the sidebar newsletter card on single Events, so
 * the <label> can animate between resting (placeholder) and floated
 * (above input) positions via CSS.
 */

( function () {
	function initFloatingLabels() {
		const fields = document.querySelectorAll(
			':is(.site-footer, .corsa-newsletter-card) .gform_wrapper .gfield--type-email'
		);

		fields.forEach( ( field ) => {
			const input = field.querySelector( 'input' );
			if ( ! input ) {
				return;
			}

			function update() {
				field.classList.toggle(
					'gf-floating',
					document.activeElement === input || input.value.length > 0
				);
			}

			input.addEventListener( 'focus', update );
			input.addEventListener( 'blur', update );
			input.addEventListener( 'input', update );

			// Handle pre-filled values (e.g. browser autofill).
			update();
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initFloatingLabels );
	} else {
		initFloatingLabels();
	}
} )();
